import TabPanel from "../Reusable/Tab";
//@ts-ignore
import { FileUpload } from "@careinfo/file-upload-service";
import EditReturnBranch from "./EditReturnBranch";

const SwitchTab = (props: any) => {
  const {
    handleEdit,
    isLoading,
    data,
    handleAttachConsignment,
    handlePrint,
    handleToggleMarkAsDone,
    isPrintLoading,
    handlecheckConsignments,
    gridData,
    id,
    handleStatusChange,
    defaultValue,
  } = props;

  return (
    <>
      <>
        <TabPanel
          tabTitle={["Update", "Documents"]}
          tabPanels={[
            <>
              <EditReturnBranch
                handleEdit={handleEdit}
                isLoading={isLoading}
                data={data}
                handleAttachConsignment={handleAttachConsignment}
                handlePrint={handlePrint}
                handleToggleMarkAsDone={handleToggleMarkAsDone}
                isPrintLoading={isPrintLoading}
                handlecheckConsignments={handlecheckConsignments}
                gridData={gridData}
                handleStatusChange={handleStatusChange}
                defaultValue={defaultValue}
              />
            </>,
            <>
              <FileUpload object_id={id} />
            </>,
          ]}
        />
      </>
    </>
  );
};

export default SwitchTab;
